/*
 * @FilePath: /kitchen-online-web/src/3DEngine/render/renderTypes/renderHType.ts
 * @Author: Yongchao Wang
 * @Date: 2021-12-27 15:17:24
 * @LastEditors: Xiaohua Zhu
 * @LastEditTime: 2022-06-23 13:54:48
 */
import { Vector2, Vector3 } from '@babylonjs/core';
import RenderBaseType from '@/3DEngine/render/renderTypes/renderBaseType';
import { SidePlatePosition, LengthLocation, LengthType, BASICTYPE_ENUM, SidePlateSequence, BASICLENGTHTYPE_ENUM, CALLOUTLINE_TITLE, CALLOUTLINE_TYPE, } from '@/3DEngine/render/utils/enum';
import { FRAMEDEPTH, 
// MINIMUM_LTYPE_L1,
// MINIMU_CAMERA_DISTANCE,
SKIRTINGBOARDCONFIG, 
// TOPFRAME_GROUND,
TOPFRAME_GROUND, AISLE_WIDTH, MINIMUM_WALL_WIDTH, GAP_BETWEEN_WALL_AND_CABINET, FRAMECATEGORY, } from '@/3DEngine/render/utils/kitchenConfig';
import { checkFrameIsHighFrame, checkPreFrameIsHighFrame, } from '@/3DEngine/render/utils/renderUtils';
import LengthX from '@/3DEngine/render/lengthTypes/lengthX';
import LengthZ from '@/3DEngine/render/lengthTypes/lengthZ';
import LengthP2Z from '@/3DEngine/render/lengthTypes/lengthP2Z';
import LengthP2X from '@/3DEngine/render/lengthTypes/lengthP2X';
import Ground from '@/3DEngine/render/room/ground';
import MeshManage from '@/3DEngine/render/meshManage';
import renderNoFrame from '@/3DEngine/render/specialHandler/renderNoFrame';
import { renderSkirtingBoardUtils, renderTopPanelUtils } from './renderHTypeUtils';
import { calloutLineFilter } from '../../utils/lengthUtils';
import { isHighCabinet } from '../../utils/templatejsonUtils';
// import LengthP2X from '../lengthTypes/lengthP2X';
export default class RenderHType extends RenderBaseType {
    // templateJson中数据依然是Length1,Length2。UI部分传参依然是L1,L2
    renderTop() {
        var _a, _b, _c, _d;
        if (!((_c = (_b = (_a = this === null || this === void 0 ? void 0 : this.templateJson) === null || _a === void 0 ? void 0 : _a.top) === null || _b === void 0 ? void 0 : _b.length1) === null || _c === void 0 ? void 0 : _c.frames)) {
            return;
        }
        this.topLength1 = new LengthX(this.templateJson, this.scene, LengthLocation.Top, LengthType.Length1, this.copyTemplateJson);
        this.topLength3 = new LengthP2X(this.templateJson, this.scene, LengthLocation.Top, LengthType.Length3, this.copyTemplateJson);
        this.putTopCupboard();
        if (((_d = this === null || this === void 0 ? void 0 : this.templateJson) === null || _d === void 0 ? void 0 : _d.version) > '2.2') {
            this.renderSidePlatesByType(SidePlatePosition.Top);
        }
        else {
            this.renderSidePlates(SidePlatePosition.Top);
        }
    }
    renderBottom() {
        var _a, _b, _c, _d;
        if (!((_c = (_b = (_a = this === null || this === void 0 ? void 0 : this.templateJson) === null || _a === void 0 ? void 0 : _a.bottom) === null || _b === void 0 ? void 0 : _b.length1) === null || _c === void 0 ? void 0 : _c.frames)) {
            return;
        }
        this.bottomLength1 = new LengthX(this.templateJson, this.scene, LengthLocation.Bottom, LengthType.Length1, this.copyTemplateJson);
        const json = JSON.parse(JSON.stringify(this.templateJson));
        json.bottom.length2 = {
            frames: [],
            length: 240,
            otherSealPlateLength: null,
            rlength: 0,
            sealPlate: null,
            sidePlates: null,
        };
        this.bottomLength2 = new LengthZ(json, this.scene, LengthLocation.Bottom, LengthType.Length2, this.copyTemplateJson);
        this.bottomLength3 = new LengthP2X(this.templateJson, this.scene, LengthLocation.Bottom, LengthType.Length3, this.copyTemplateJson);
        this.bottomLength4 = new LengthP2Z(this.templateJson, this.scene, LengthLocation.Bottom, LengthType.Length4, this.copyTemplateJson);
        this.putBottomCupboard();
        // this.renderSkirtingBoard();
        this.renderTopPanel();
        if (((_d = this === null || this === void 0 ? void 0 : this.templateJson) === null || _d === void 0 ? void 0 : _d.version) > '2.2') {
            this.renderSidePlatesByType(SidePlatePosition.Bottom);
        }
        else {
            this.renderSidePlates(SidePlatePosition.Bottom);
        }
    }
    renderRoom() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        // 没有墙地面信息不渲染
        if (!((_a = this.templateJson) === null || _a === void 0 ? void 0 : _a.other)) {
            return;
        }
        // const l2Width = MINIMUM_WALL_WIDTH;
        const l1Width = Math.max(this.bottomLength1.getSideLength(MINIMUM_WALL_WIDTH), this.bottomLength3.getSideLength(MINIMUM_WALL_WIDTH));
        const l2Width = AISLE_WIDTH + FRAMEDEPTH.BOTTOM * 2;
        this.groundNode = new Ground(this.scene, this.engine, { width: l1Width, height: l2Width });
        this.bottomLength1.createWall(l1Width);
        this.bottomLength2.createWall(l2Width);
        this.bottomLength3.createWall(l1Width, l2Width);
        // this.bottomLength4.createWall(l1Width, l2Width);
        const wallInfo = (_c = (_b = this.templateJson) === null || _b === void 0 ? void 0 : _b.other) === null || _c === void 0 ? void 0 : _c.wall;
        this.changeWallColor(wallInfo.baseModelUrl, wallInfo.normalModelUrl, { width: wallInfo.width * 0.001, height: wallInfo.height * 0.001 });
        const grounds = [
            new Vector2(0, -GAP_BETWEEN_WALL_AND_CABINET),
            new Vector2(-l1Width, -GAP_BETWEEN_WALL_AND_CABINET),
            new Vector2(-l1Width, l2Width + 2 * GAP_BETWEEN_WALL_AND_CABINET),
            new Vector2(0, l2Width + 2 * GAP_BETWEEN_WALL_AND_CABINET),
        ];
        this.groundNode.createGround(grounds, new Vector3(0, 0, 0));
        this.groundNode.changeMaterial((_f = (_e = (_d = this.templateJson) === null || _d === void 0 ? void 0 : _d.other) === null || _e === void 0 ? void 0 : _e.floor) === null || _f === void 0 ? void 0 : _f.baseModelUrl, (_j = (_h = (_g = this.templateJson) === null || _g === void 0 ? void 0 : _g.other) === null || _h === void 0 ? void 0 : _h.floor) === null || _j === void 0 ? void 0 : _j.normalModelUrl, { width: this.templateJson.other.floor.width * 0.001, height: this.templateJson.other.floor.height * 0.001 });
        this.roomMeshes = [
            (_k = this === null || this === void 0 ? void 0 : this.groundNode) === null || _k === void 0 ? void 0 : _k.groundMesh,
            (_m = (_l = this.bottomLength1) === null || _l === void 0 ? void 0 : _l.wallNode) === null || _m === void 0 ? void 0 : _m.wallMesh,
            (_p = (_o = this.bottomLength2) === null || _o === void 0 ? void 0 : _o.wallNode) === null || _p === void 0 ? void 0 : _p.wallMesh,
            (_r = (_q = this.bottomLength3) === null || _q === void 0 ? void 0 : _q.wallNode) === null || _r === void 0 ? void 0 : _r.wallMesh,
            (_t = (_s = this.bottomLength4) === null || _s === void 0 ? void 0 : _s.wallNode) === null || _t === void 0 ? void 0 : _t.wallMesh,
        ];
        this.renderWindow();
    }
    renderWindow() {
        const lengthList = [LengthType.Length1, LengthType.Length3];
        lengthList.forEach((item, i) => {
            var _a, _b, _c, _d;
            const { frame, window } = this.getWindowFrame('bottom', item);
            if (frame) {
                if (!i) {
                    this.bottomLength1.createWindow(frame, window);
                    this.addMesh((_b = (_a = this.bottomLength1) === null || _a === void 0 ? void 0 : _a.windowNode) === null || _b === void 0 ? void 0 : _b.windowMesh);
                }
                else {
                    this.bottomLength3.createWindow(frame, window);
                    this.addMesh((_d = (_c = this.bottomLength3) === null || _c === void 0 ? void 0 : _c.windowNode) === null || _d === void 0 ? void 0 : _d.windowMesh);
                }
            }
        });
        // 如果窗户隐藏自动隐藏窗户
        if (!this.windowVisiable) {
            this.showWindow(this.windowVisiable);
        }
    }
    renderSidePlates(position) {
        const hTypeLength1 = this.templateJson[position].length1;
        const hTypeLength3 = this.templateJson[position].length3;
        const l1SidePlatesArray = hTypeLength1.sidePlates;
        const l3SidePlatesArray = hTypeLength3.sidePlates;
        if (l1SidePlatesArray) {
            if (l1SidePlatesArray.length === 1) {
                const firstFrameJson = hTypeLength1.frames[0];
                const l1 = this[`${position}Length1`];
                const l1FirstSidePlateRotationData = l1.renderSidePlate(firstFrameJson, l1SidePlatesArray, SidePlateSequence.First, position);
                this.addRotationMeshes(l1FirstSidePlateRotationData);
            }
            else {
                const firstFrameJson = hTypeLength1.frames[0];
                const lastFrameJson = hTypeLength1.frames[hTypeLength1.frames.length - 1];
                const l1 = this[`${position}Length1`];
                const l1FirstSidePlateRotationData = l1.renderSidePlate(firstFrameJson, l1SidePlatesArray, SidePlateSequence.First, position);
                const l1LastSidePlateRotationData = l1.renderSidePlate(lastFrameJson, l1SidePlatesArray, SidePlateSequence.Last, position);
                this.addRotationMeshes(l1FirstSidePlateRotationData);
                this.addRotationMeshes(l1LastSidePlateRotationData);
            }
            this.addSidePlatesMeshes(l1SidePlatesArray);
        }
        if (l3SidePlatesArray) {
            if (l3SidePlatesArray.length === 1) {
                const firstFrameJson = hTypeLength3.frames[0];
                const l3 = this[`${position}Length3`];
                const l3FirstSidePlateRotationData = l3.renderSidePlate(firstFrameJson, l3SidePlatesArray, SidePlateSequence.First, position);
                this.addRotationMeshes(l3FirstSidePlateRotationData);
            }
            else {
                const firstFrameJson = hTypeLength3.frames[0];
                const lastFrameJson = hTypeLength3.frames[hTypeLength3.frames.length - 1];
                const l3 = this[`${position}Length3`];
                const l3FirstSidePlateRotationData = l3.renderSidePlate(firstFrameJson, l3SidePlatesArray, SidePlateSequence.First, position);
                const l3LastSidePlateRotationData = l3.renderSidePlate(lastFrameJson, l3SidePlatesArray, SidePlateSequence.Last, position);
                this.addRotationMeshes(l3FirstSidePlateRotationData);
                this.addRotationMeshes(l3LastSidePlateRotationData);
            }
            this.addSidePlatesMeshes(l3SidePlatesArray);
        }
    }
    renderSidePlatesByType(position) {
        var _a;
        const lTypeLength1 = this.templateJson[position].length1;
        const lTypeLength3 = this.templateJson[position].length3;
        const length1SidePlatesArr = lTypeLength1.sidePlatesV2;
        const length3SidePlatesArr = lTypeLength3.sidePlatesV2;
        this[`${position}Length1`].renderSidePlateByLength(length1SidePlatesArr, position);
        this[`${position}Length3`].renderSidePlateByLength(length3SidePlatesArr, position);
        if (((_a = this.refrigeraror) === null || _a === void 0 ? void 0 : _a.type) === position) {
            this[`${position}Length${this.refrigeraror.length}`].setRefrigerator(this.refrigeraror, position);
        }
    }
    setCalloutLine() {
        var _a;
        if (this.templateJson.bottom.type === 'H') {
            this.setBottomCalloutLine();
        }
        // version2.0 无顶柜的时候top为null
        if (((_a = this.templateJson.top) === null || _a === void 0 ? void 0 : _a.type) === 'H') {
            this.setTopCalloutLine();
        }
    }
    // 顶柜只有高柜 底柜只有一个柜体
    isOnlyHighCabinet() {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!((_a = this.templateJson) === null || _a === void 0 ? void 0 : _a.top)) {
            return false;
        }
        const topLength1 = (_d = (_c = (_b = this.templateJson) === null || _b === void 0 ? void 0 : _b.top) === null || _c === void 0 ? void 0 : _c.length3) === null || _d === void 0 ? void 0 : _d.frames;
        const bottomLength1 = (_g = (_f = (_e = this.templateJson) === null || _e === void 0 ? void 0 : _e.bottom) === null || _f === void 0 ? void 0 : _f.length3) === null || _g === void 0 ? void 0 : _g.frames;
        if (!topLength1 || !bottomLength1) {
            return false;
        }
        if (isHighCabinet(topLength1[0].categoryId) && bottomLength1.length === 1) {
            return true;
        }
        return false;
    }
    isHighAndLowSameLength(length) {
        if (this.templateJson.bottom[length].frames.length === 0) {
            return false;
        }
        const isHighAndLow = this.templateJson.bottom.highAndLow;
        const { CATEGORY_1, CATEGORY_2 } = FRAMECATEGORY;
        let count = 0;
        this.templateJson.bottom[length].frames.forEach((element) => {
            if (element) {
                if (element.categoryId === CATEGORY_1 || element.categoryId === CATEGORY_2) {
                    count += 1;
                }
            }
        });
        return count === 2 && isHighAndLow;
    }
    setBottomCalloutLine() {
        var _a, _b;
        const { Length, EndHeight, EndDepth, StartHeight, StartDepth, } = CALLOUTLINE_TYPE;
        const l1HighAndLowSameLength = this.isHighAndLowSameLength(LengthType.Length1);
        const l3HighAndLowSameLength = this.isHighAndLowSameLength(LengthType.Length3);
        const lTypeL1ShowList = [Length, EndHeight, EndDepth];
        let lTypeL3ShowList = [Length, EndHeight, EndDepth];
        let highAndLowShowList = [Length, EndHeight, EndDepth, StartHeight, StartDepth];
        if (this.isOnlyHighCabinet()) {
            lTypeL3ShowList = [];
            highAndLowShowList = [];
        }
        const calloutLineLength1 = (_a = this.bottomLength1) === null || _a === void 0 ? void 0 : _a.getFramesCalloutLine(LengthLocation.Bottom);
        const calloutLineLength3 = (_b = this.bottomLength3) === null || _b === void 0 ? void 0 : _b.getFramesCalloutLine(LengthLocation.Bottom, CALLOUTLINE_TITLE.L2);
        const calloutLines = {
            length1: calloutLineFilter(l1HighAndLowSameLength ? highAndLowShowList : lTypeL1ShowList, calloutLineLength1),
            length3: calloutLineFilter(l3HighAndLowSameLength ? highAndLowShowList : lTypeL3ShowList, calloutLineLength3),
        };
        this.calloutLineInfo.bottom = calloutLines;
    }
    setTopCalloutLine() {
        var _a, _b;
        const { Length, EndHeight, EndDepth } = CALLOUTLINE_TYPE;
        const lTypeL1ShowList = [Length, EndHeight, EndDepth];
        let lTypeL3ShowList = [Length, EndHeight, EndDepth];
        if (this.isOnlyHighCabinet()) {
            lTypeL3ShowList = [Length];
        }
        const calloutLineLength1 = (_a = this.topLength1) === null || _a === void 0 ? void 0 : _a.getFramesCalloutLine(LengthLocation.Top);
        const calloutLineLength3 = (_b = this.topLength3) === null || _b === void 0 ? void 0 : _b.getFramesCalloutLine(LengthLocation.Top, CALLOUTLINE_TITLE.L2);
        const calloutLines = {
            length1: calloutLineFilter(lTypeL1ShowList, calloutLineLength1),
            length3: calloutLineFilter(lTypeL3ShowList, calloutLineLength3),
        };
        this.calloutLineInfo.top = calloutLines;
    }
    // eslint-disable-next-line max-statements
    renderTopPanel() {
        renderTopPanelUtils(this);
    }
    renderSkirtingBoard() {
        renderSkirtingBoardUtils(this);
    }
    // eslint-disable-next-line max-statements
    putBottomCupboard() {
        var _a, _b, _c, _d, _e, _f;
        const sealPlateData = this.getLengthSealPlate('bottom');
        // version 2.3 add by xiaohua.zhu 20220330 侧板对象结构有调整 需要判断版本
        const sidePlateDepth = this.getSidePlateDepth('length1');
        let datumPoint = null;
        let sealPlateMesh = null;
        const sealPlateLengthXPos = this.bottomLength1.getSealPlatePos(this.templateJson, BASICTYPE_ENUM.bottom);
        // 如果为null的话就变成1
        const sealPlateLengthP2XPos = this.bottomLength3.getSealPlatePos(this.templateJson, BASICTYPE_ENUM.bottom);
        // 移动柜子到指定位置  l1的底柜
        (_c = (_b = (_a = this === null || this === void 0 ? void 0 : this.templateJson) === null || _a === void 0 ? void 0 : _a.bottom) === null || _b === void 0 ? void 0 : _b.length1) === null || _c === void 0 ? void 0 : _c.frames.forEach((element, index) => {
            // 第一个柜子放在默认位置，第二个开始往右边排列，这个和后台align好的
            if (index > 0) {
                const preEl = this.templateJson.bottom.length1.frames[index - 1];
                const preMeshManage = new MeshManage(this.scene.getMeshByName(preEl.componentBasic.id));
                const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
                // 摆放补板后柜体处理
                if (sealPlateMesh && sealPlateLengthXPos && index === sealPlateLengthXPos) {
                    datumPoint = sealPlateMesh.getDatumPoint({ x: -1, y: 1, z: 0 });
                }
                else {
                    datumPoint = preMeshManage.getDatumPoint({ x: -1, y: 1, z: 0 }, false);
                }
                const { rotation } = meshManage.moveModelToPosition(datumPoint, { x: -1, y: 1, z: 0 });
                const obj = {};
                obj[element.componentBasic.id] = rotation;
                this.rotationMeshes = Object.assign(Object.assign({}, this.rotationMeshes), obj);
            }
            else {
                const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
                meshManage.setModelPosition({
                    x: -meshManage.getModelSize().x * 0.5 - sidePlateDepth,
                    y: SKIRTINGBOARDCONFIG.HEIGHT,
                    z: meshManage.getModelSize().z * 0.5,
                });
            }
            if (element.ventilator) {
                const tmpRotation = { x: 0, y: 0, z: 0 };
                this.renderVentilator(element, tmpRotation);
            }
            // 补板处理 需要在摆完柜子之后进行
            if (sealPlateLengthXPos && index === sealPlateLengthXPos - 1) {
                const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
                // 渲染补板
                sealPlateMesh = this.bottomLength1.renderSealPlate(sealPlateData.length1, meshManage, BASICTYPE_ENUM.bottom, element, this);
                // 获取模型最右边坐标数据
                datumPoint = sealPlateMesh === null || sealPlateMesh === void 0 ? void 0 : sealPlateMesh.getDatumPoint({ x: -1, y: 1, z: 0 });
            }
        });
        datumPoint = null; // 还原默认值
        sealPlateMesh = null; // 还原默认值
        // 对向的柜子  l3的底柜
        (_f = (_e = (_d = this === null || this === void 0 ? void 0 : this.templateJson) === null || _d === void 0 ? void 0 : _d.bottom) === null || _e === void 0 ? void 0 : _e.length3) === null || _f === void 0 ? void 0 : _f.frames.forEach((element, index) => {
            var _a, _b, _c, _d;
            if (index > 0) {
                const preEl = this.templateJson.bottom.length3.frames[index - 1];
                const preMeshManage = new MeshManage(this.scene.getMeshByName(preEl.componentBasic.id));
                const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
                // 摆放补板后柜体处理
                if (sealPlateMesh && sealPlateLengthP2XPos && index === sealPlateLengthP2XPos) {
                    datumPoint = sealPlateMesh.getDatumPoint({ x: -1, y: 0, z: 1 });
                }
                else {
                    datumPoint = preMeshManage.getDatumPoint({ x: -1, y: 0, z: 1 }, false);
                }
                const { rotation } = meshManage.moveModelToPosition(datumPoint, { x: -1, y: 0, z: 1 });
                if (sealPlateLengthP2XPos && index === sealPlateLengthP2XPos) {
                    meshManage.mesh.position.z += meshManage.getModelSize().z;
                }
                this.rotationMeshes[element.componentBasic.id] = rotation;
            }
            else {
                // 第一个柜子的基准点为l1的第一个柜子  中间过道宽度为120
                const preEl = (_c = (_b = (_a = this === null || this === void 0 ? void 0 : this.templateJson) === null || _a === void 0 ? void 0 : _a.bottom) === null || _b === void 0 ? void 0 : _b.length1) === null || _c === void 0 ? void 0 : _c.frames[0];
                const preMeshManage = new MeshManage(this.scene.getMeshByName((_d = preEl === null || preEl === void 0 ? void 0 : preEl.componentBasic) === null || _d === void 0 ? void 0 : _d.id));
                const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
                const rotation = meshManage.addRotation(0, -Math.PI, 0); // l2的柜子旋转180度
                this.rotationMeshes[element.componentBasic.id] = rotation;
                const position = {
                    x: -meshManage.getModelSize().x / 2 - sidePlateDepth,
                    y: SKIRTINGBOARDCONFIG.HEIGHT,
                    z: (preMeshManage.getModelSize().z || FRAMEDEPTH.BOTTOM) + AISLE_WIDTH + FRAMEDEPTH.BOTTOM / 2,
                };
                meshManage.setModelPosition(position);
            }
            if (element.ventilator) {
                const tmpRotation = { x: 0, y: -Math.PI, z: 0 };
                this.renderVentilator(element, tmpRotation);
            }
            // 补板处理 需要在摆完柜子之后进行
            if (sealPlateLengthP2XPos && index === sealPlateLengthP2XPos - 1) {
                const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
                // 渲染补板
                sealPlateMesh = this.bottomLength3.renderSealPlate(sealPlateData.length3, meshManage, BASICTYPE_ENUM.bottom, element, this);
            }
        });
    }
    putTopCupboard() {
        var _a, _b, _c, _d, _e, _f;
        const topToGround = TOPFRAME_GROUND(this.templateJson);
        const sealPlateData = this.getLengthSealPlate(BASICTYPE_ENUM.top);
        // version 2.3 add by xiaohua.zhu 20220330 侧板对象结构有调整 需要判断版本
        const sidePlateDepth = this.getSidePlateDepth('length1', 'top');
        let datumPoint = null;
        let sealPlateMesh = null;
        const sealPlateLengthXPos = this.topLength1.getSealPlatePos(this.templateJson, BASICTYPE_ENUM.top);
        const sealPlateLengthP2XPos = this.topLength3.getSealPlatePos(this.templateJson, BASICTYPE_ENUM.top);
        // 顶部只有高柜情况
        const checkLengthXPosTopNoFrames = LengthX.checkTopNoFrames(this.templateJson, BASICTYPE_ENUM.top);
        if (checkLengthXPosTopNoFrames) {
            sealPlateMesh = renderNoFrame.renderSealPlate(sealPlateData.length1, BASICTYPE_ENUM.top, BASICLENGTHTYPE_ENUM.length1, this);
        }
        // 移动柜子到指定位置  l1的顶柜
        (_c = (_b = (_a = this === null || this === void 0 ? void 0 : this.templateJson) === null || _a === void 0 ? void 0 : _a.top) === null || _b === void 0 ? void 0 : _b.length1) === null || _c === void 0 ? void 0 : _c.frames.forEach((element, index) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            // 第一个柜子放在默认位置，第二个开始往右边排列，这个和后台align好的
            if (checkPreFrameIsHighFrame((_c = (_b = (_a = this === null || this === void 0 ? void 0 : this.templateJson) === null || _a === void 0 ? void 0 : _a.top) === null || _b === void 0 ? void 0 : _b.length1) === null || _c === void 0 ? void 0 : _c.frames, index)) {
                const preEl = (_f = (_e = (_d = this === null || this === void 0 ? void 0 : this.templateJson) === null || _d === void 0 ? void 0 : _d.top) === null || _e === void 0 ? void 0 : _e.length1) === null || _f === void 0 ? void 0 : _f.frames[index - 1];
                const preMeshManage = new MeshManage(this.scene.getMeshByName(preEl.componentBasic.id));
                const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
                const point = preMeshManage.getDatumPoint({ x: -1, y: 1, z: 0 }, false);
                point.y = TOPFRAME_GROUND(this.templateJson) - meshManage.getModelSize().y;
                const { rotation } = meshManage.moveModelToPosition(point, { x: -1, y: 1, z: 0 });
                this.rotationMeshes[element.componentBasic.id] = rotation;
                // 第一个柜子放在默认位置，第二个开始往右边排列，这个和后台align好的
            }
            else if (index > 0) {
                const preEl = (_j = (_h = (_g = this === null || this === void 0 ? void 0 : this.templateJson) === null || _g === void 0 ? void 0 : _g.top) === null || _h === void 0 ? void 0 : _h.length1) === null || _j === void 0 ? void 0 : _j.frames[index - 1];
                const preMeshManage = new MeshManage(this.scene.getMeshByName(preEl.componentBasic.id));
                const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
                // 摆放补板后柜体处理
                if (sealPlateMesh && sealPlateLengthXPos && index === sealPlateLengthXPos) {
                    datumPoint = sealPlateMesh.getDatumPoint({ x: -1, y: 1, z: 0 });
                }
                else {
                    datumPoint = preMeshManage.getDatumPoint({ x: -1, y: 1, z: 0 }, false);
                }
                const { rotation } = meshManage.moveModelToPosition(datumPoint, { x: -1, y: 1, z: 0 });
                this.rotationMeshes[element.componentBasic.id] = rotation;
                if (checkFrameIsHighFrame(element)) {
                    meshManage.mesh.position.y = SKIRTINGBOARDCONFIG.HEIGHT;
                }
            }
            else {
                const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
                const moveX = sealPlateMesh ? -sealPlateMesh.getModelSize().x : 0;
                meshManage.setModelPosition({
                    x: -meshManage.getModelSize().x * 0.5 - sidePlateDepth + moveX,
                    y: topToGround - meshManage.getModelSize().y,
                    z: meshManage.getModelSize().z * 0.5,
                });
            }
            // 补板处理
            if (sealPlateLengthXPos && index === sealPlateLengthXPos - 1 && !checkLengthXPosTopNoFrames) {
                const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
                // 渲染补板
                sealPlateMesh = this.topLength1.renderSealPlate(sealPlateData.length1, meshManage, BASICTYPE_ENUM.top, element, this);
            }
        });
        datumPoint = null;
        sealPlateMesh = null;
        const checkLengthP2XPosTopNoFrames = LengthP2X.checkTopNoFrames(this.templateJson, BASICTYPE_ENUM.top);
        if (checkLengthP2XPosTopNoFrames) {
            sealPlateMesh = renderNoFrame.renderSealPlate(sealPlateData.length3, BASICTYPE_ENUM.top, BASICLENGTHTYPE_ENUM.length3, this);
        }
        // l2的顶柜
        console.log('-------------', sealPlateLengthP2XPos);
        (_f = (_e = (_d = this === null || this === void 0 ? void 0 : this.templateJson) === null || _d === void 0 ? void 0 : _d.top) === null || _e === void 0 ? void 0 : _e.length3) === null || _f === void 0 ? void 0 : _f.frames.forEach((element, index) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
            // 第一个柜子放在默认位置，第二个开始往右边排列，这个和后台align好的
            if (index > 0) {
                const preEl = (_c = (_b = (_a = this === null || this === void 0 ? void 0 : this.templateJson) === null || _a === void 0 ? void 0 : _a.top) === null || _b === void 0 ? void 0 : _b.length3) === null || _c === void 0 ? void 0 : _c.frames[index - 1];
                const preMeshManage = new MeshManage(this.scene.getMeshByName(preEl.componentBasic.id));
                const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
                // 摆放补板后柜体处理
                if (sealPlateMesh && sealPlateLengthP2XPos && index === sealPlateLengthP2XPos) {
                    datumPoint = sealPlateMesh.getDatumPoint({ x: -1, y: 0, z: 1 });
                }
                else {
                    datumPoint = preMeshManage.getDatumPoint({ x: -1, y: 0, z: 1 }, false);
                }
                const { rotation } = meshManage.moveModelToPosition(datumPoint, { x: -1, y: 0, z: 1 });
                if (sealPlateLengthP2XPos && index === sealPlateLengthP2XPos) {
                    meshManage.mesh.position.z += preMeshManage.getModelSize().z;
                }
                this.rotationMeshes[element.componentBasic.id] = rotation;
                if (checkFrameIsHighFrame(element)) {
                    meshManage.mesh.position.y = SKIRTINGBOARDCONFIG.HEIGHT;
                }
            }
            else {
                // l2的顶柜的位置使用l2的第一个底柜为基准点 如果是U型底柜有可能l3没有柜子 所以需要根据l2的最后一个柜子的位置来
                const bottomFirstEl = ((_f = (_e = (_d = this === null || this === void 0 ? void 0 : this.templateJson) === null || _d === void 0 ? void 0 : _d.bottom) === null || _e === void 0 ? void 0 : _e.length3) === null || _f === void 0 ? void 0 : _f.frames[0])
                    ? (_j = (_h = (_g = this === null || this === void 0 ? void 0 : this.templateJson) === null || _g === void 0 ? void 0 : _g.bottom) === null || _h === void 0 ? void 0 : _h.length3) === null || _j === void 0 ? void 0 : _j.frames[0]
                    : (_m = (_l = (_k = this === null || this === void 0 ? void 0 : this.templateJson) === null || _k === void 0 ? void 0 : _k.bottom) === null || _l === void 0 ? void 0 : _l.length2) === null || _m === void 0 ? void 0 : _m.frames[((_r = (_q = (_p = (_o = this === null || this === void 0 ? void 0 : this.templateJson) === null || _o === void 0 ? void 0 : _o.bottom) === null || _p === void 0 ? void 0 : _p.length2) === null || _q === void 0 ? void 0 : _q.frames) === null || _r === void 0 ? void 0 : _r.length) - 1];
                const preMeshManage = new MeshManage(this.scene.getMeshByName((_s = bottomFirstEl === null || bottomFirstEl === void 0 ? void 0 : bottomFirstEl.componentBasic) === null || _s === void 0 ? void 0 : _s.id));
                const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
                const rotation = meshManage.addRotation(0, -Math.PI, 0);
                this.rotationMeshes[element.componentBasic.id] = rotation;
                const moveX = sealPlateMesh ? -sealPlateMesh.getModelSize().x : 0;
                const position = {
                    x: -meshManage.getModelSize().x / 2 - sidePlateDepth + moveX,
                    y: topToGround - meshManage.getModelSize().y,
                    z: (((_u = (_t = preMeshManage === null || preMeshManage === void 0 ? void 0 : preMeshManage.mesh) === null || _t === void 0 ? void 0 : _t.position) === null || _u === void 0 ? void 0 : _u.z) || FRAMEDEPTH.BOTTOM * 4) // 底部没有底柜 x深度 + 过道 + p2x深度
                        + ((preMeshManage === null || preMeshManage === void 0 ? void 0 : preMeshManage.getModelSize().z) / 2 || 0)
                        - meshManage.getModelSize().z / 2,
                };
                meshManage.setModelPosition(position);
            }
            // 补板处理 需要在摆完柜子之后进行
            if (sealPlateLengthP2XPos && index === sealPlateLengthP2XPos - 1 && !checkLengthP2XPosTopNoFrames) {
                const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
                // 渲染补板
                sealPlateMesh = this.topLength3.renderSealPlate(sealPlateData.length3, meshManage, BASICTYPE_ENUM.top, element, this);
            }
        });
    }
    /**
     * @description: 获取相机最佳位置的参数
     * @param {*}
     * @return {*} {target:Vector3,position:Vector3}
     * @author: Yongchao Wang
     */
    getCameraBestConfig(fov, allMeshes, camera) {
        const max = new Vector3(0, TOPFRAME_GROUND(this.templateJson), this.bottomLength2.getSideLength());
        let minx = Math.max(this.bottomLength1.getSideLength(), this.bottomLength3.getSideLength(), MINIMUM_WALL_WIDTH);
        // L1L3尺寸过长时看不到柜深的标线 加上0.8
        minx = minx > MINIMUM_WALL_WIDTH ? minx + 0.8 : minx;
        const min = new Vector3(-minx, 0, 0);
        const size = { x: max.x - min.x, y: max.y - min.y, z: max.z - min.z };
        const target = { x: -size.x / 2, y: size.y / 2, z: size.z / 2 };
        const position = { y: size.y / 2, z: size.z / 2, x: 0 };
        position.x = -(target.y) / Math.tan(fov / 2) - size.x;
        // eslint-disable-next-line no-underscore-dangle
        const ratio = this.scene._engine.getAspectRatio(camera);
        const x = -(target.z) / Math.tan((fov * ratio) / 2) - size.x;
        // 如果是使用纵向视角的x值，那需要远离0.5米给顶部标注一些位置
        position.x = Math.min(x, position.x);
        // 计算横向视角刚好看到所有柜子，视角中线垂直与L两边连线，并与相机形成等腰三角形
        // const hFov = (fov * ratio) / 2;
        // const deviation = 2 * (Math.PI / 180);
        const lowerAlphaLimit = Math.PI / 2;
        const upperAlphaLimit = Math.PI * 1.5;
        return {
            target: new Vector3(target.x, target.y, target.z),
            position: new Vector3(position.x, position.y, position.z),
            lowerAlphaLimit,
            upperAlphaLimit,
            alpha: Math.PI,
            beta: 1.4492930597593832,
        };
    }
}
